import RoleFormAdmin from "./RoleCommonFormAdmin";
import CommonDataTable from "../../../components/CommonDataTable";
import React, { useState, useEffect, useCallback } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { createUsersRoles,  getUsersRolesAdminList, updateUsersRoles } from "../../../services/tenant/tenant";
import { toast } from "../../../components/AppToast";
import { useSelector } from "react-redux";

const RoleManagementAdmin = () => {
  const [editData, setEditData] = useState(null);
  const [addNewRole, setAddNewRole] = useState(false);
  const [RoleData, setRoleData] = useState([]);
  const [readOnly, setReadOnly] = useState(null);
  const [columns, setColumns] = useState([]);
  const [partners, setPartners] = useState([]);
  const { _id } = useSelector((state) => state?.login?.userDetail);
  const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, rowData: null });
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // Fetch Roles
  const fetchData = useCallback(async (pageNo , pageSizeNo) => {
    try {
      const res = await getUsersRolesAdminList(pageNo , pageSizeNo);      
      const total = res.total;
      const sortedData = res.data.sort((a, b) => a.status - b.status);

      const transformedRows = sortedData?.map((row, index) => ({
        id: row._id,
        // partner_name: row?.partnerId?.partner_name,
        roleStatus:
          row?.status === 1
            ? "Active"
            : row?.status === 2
              ? "Pending"
              : row?.status === 3
                ? "Inactive"
                : "-",
        formcreatedAt: row.createdAt
          ? new Date(row.createdAt).toLocaleString()
          : "",
        formupdatedAt: row.updatedAt
          ? new Date(row.updatedAt).toLocaleString()
          : "",
        ...row
      })) || [];

      setRoleData(transformedRows);
      setTotalCount(total);
      const roleColumns = [
        {
          field: "__actions",
          headerName: "",
          width: 20,
          sortable: false,
          filterable: false,
          disableColumnMenu: true,
          renderCell: (params) => (
            <IconButton size="small" onClick={(e) => handleOpenMenu(e, params.row)}>
              <MoreVertIcon fontSize="small" />
            </IconButton>
          ),
        },
        { field: "roleID", headerName: "Role ID", width: 200 },
        { field: "roleDescription", headerName: "Description", width: 250 },
        // { field: "partner_name", headerName: "Partner", width: 200 },
        { field: "roleType", headerName: "Role Type", width: 120 },
        { field: "roleStatus", headerName: "Status", width: 120 },
        { field: "formcreatedAt", headerName: "Created Date", width: 180 },
        { field: "formupdatedAt", headerName: "Updated Date", width: 180 },
      ];
      setColumns(roleColumns);
    } catch (err) {
      toast.error(err);
    }
  }, []);



  const handleOpenMenu = (e, row) => {
    e.stopPropagation();
    setMenuAnchorEl(e.currentTarget);
    setMenuRow(row);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const handleView = () => {
    if (menuRow) {
      setEditData(menuRow);
      setReadOnly(true);
    }
    handleCloseMenu();
  };

  const handleEdit = () => {
    if (menuRow) {
      setEditData(menuRow);
      setReadOnly(false);
    }
    handleCloseMenu();
  };

  const handleToggleStatus = async () => {
    if (!menuRow) return;
    const status = menuRow.status === 1 ? 3 : 1;
    await updateUsersRoles(menuRow._id, { status });
    toast.success(`Role ${status === 1 ? "Activated" : "Deactivated"}`);
    fetchData(page, pageSize);
    handleCloseMenu();
  };

  const handleAddNew = () => {
    setAddNewRole(true);
    setEditData(null);
  };

  useEffect(() => {
    fetchData(page, pageSize);
  }, [fetchData , page, pageSize]);


  const onSubmitHandler = async (data) => {
    try {
      const res = await createUsersRoles(data)
      toast.success(res?.message || "Role created successfully");
      resetHandler();
    } catch (err) {
      toast.error(err);
    }
  }
  const onSubmitUpdateHandler = async (data, id) => {
    try {
      const res = await updateUsersRoles(id, data);
      toast.success(res?.message || "Role updated successfully");
      resetHandler();
    } catch (err) {
      toast.error(err);
    }
  }


  const onCancelhandler = (value) => {
    value && setAddNewRole(false);
    value && setEditData(null);
  };
  const resetHandler = () => {
    setAddNewRole(false);
    setEditData(null);
    setContextMenu({ visible: false, x: 0, y: 0, rowData: null });
    fetchData(page, pageSize);
  };

  return (
    <div className="card shadow-lg main-card">
      <div className="card-header bg-secondary text-white">
        <h4 className="mb-0 h6 fw-semibold">
          {!editData && !addNewRole ? "Manage Roles" : addNewRole ? "Add New Role Form" : "Update Role Form"}
        </h4>
      </div>

      {/* ✅ Breadcrumbs - Only show when adding or editing a role */}
      {(addNewRole || editData) && (
        <nav aria-label="breadcrumb" className="px-3 py-2 border-bottom bg-light mb-2">
          <ol className="breadcrumb mb-0 align-items-center">
            {/* Root crumb */}
            <li className="breadcrumb-item">
              <button
                type="button"
                className="btn btn-link p-0 text-decoration-none text-muted"
                onClick={() => {
                  setAddNewRole(false);
                  setEditData(null);
                }}
              >
                Manage Roles
              </button>
            </li>

            {/* Child crumb */}
            <li
              className="breadcrumb-item active fw-semibold text-primary"
              aria-current="page"
            >
              {addNewRole && !editData
                ? "Add New Role"
                : editData
                  ? "Update Role"
                  : "Role Details"}
            </li>
          </ol>
        </nav>
      )}



      <div className="card-body">
        {!editData && !addNewRole && (
          <CommonDataTable
            id="role-table"
            allPossibleColumns={columns}
            initialVisible={columns.map(c => c.field)}
            initialRows={RoleData}
            height={500}
            rowsPerPageOptions={[10, 25, 50, 100]}
            // onDataRefresh={fetchData}
            checkboxSelection
            exportImportPath="role"
            sampleFileUrl="/samples/role.xlsx"
            sampleFileName="role"
            showCreateButton={true}
            createButtonText="Add New Role"
            createButtonIcon="bi-plus-lg"
            onCreateClick={handleAddNew}
            enableImportButton={false}
            getRowClassName={(params) =>
              params.row.isDefault ? "default-role-row" : ""
            }
            page={page}
            pageSize={pageSize}
            rowCount={totalCount}
            onPageChange={(newPage) => setPage(newPage)}
            onPageSizeChange={(newSize) => {
              setPageSize(newSize);
              setPage(0);
            }}



            onDataRefresh={async ({ filters = [], page: p = 0, pageSize: ps = pageSize } = {}) => {
              // NOTE: this just forwards the values to your fetchHandler. For now we console.log as requested.
              console.log("ASN ....................... received onDataRefresh:", { filters, page: p, pageSize: ps });
              // call your existing fetchHandler (we'll update it to accept filters)
              // await loadList(p, ps, filters);
            }}
          />
        )}

      
        {addNewRole && (
          <RoleFormAdmin
            onSubmit={(data) => {
              onSubmitHandler(data);
            }}
            submitText="Create Role"
            cancelText="Back"
            onCancel={onCancelhandler}
            partners={partners}
          />
        )}
        {editData && (
          <RoleFormAdmin
            initialValues={editData}
            readOnly={readOnly}
            onSubmit={(data, id) => {
              onSubmitUpdateHandler(data, id)
              console.log("Update:", data);
            }}
            submitText="Update Role"
            cancelText="Back"
            onCancel={onCancelhandler}
            partners={partners}
          />
        )}

        <Menu
          open={Boolean(menuAnchorEl)}
          anchorEl={menuAnchorEl}
          onClose={handleCloseMenu}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem onClick={handleView}>
            <i className="bi bi-eye me-2"></i> View
          </MenuItem>
          <MenuItem onClick={handleEdit}>
            <i className="bi bi-pencil me-2"></i> Edit
          </MenuItem>
          {!menuRow?.isDefault && (
            <MenuItem onClick={handleToggleStatus}>
              <i
                className={`bi ${menuRow?.status === 2 ? "bi-check-circle" : "bi-x-circle"} me-2`}
              ></i>
              {menuRow?.status === 3 ? "Activate" : "Deactivate"}
            </MenuItem>
          )}
      
        </Menu>
      </div>
    </div>
  );
};

export default RoleManagementAdmin;
